<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
  <div>
      <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
<div class="scrollable p-2 h-100 w-100 relative">
<div *ngIf="!loading && parent" class="m-0 row h-100 d-flex">
  <div class="col-md-12 m-0 sticky-top border-radius-5 justify-content-center p-3 border-primary relative bg-50perc-white">
    <button class="fab-top-left" type="button" mat-mini-fab color="accent" routerLink="../../businesses">
      <fa-icon [icon]="faBack"></fa-icon>
    </button>

        <div class="d-flex align-items-center justify-content-start">
          <div *ngIf="!parent.ProfilePicture || parent.ProfilePicture?.source === ''" class="initials sm text-white link" (click)="openProfilePictureDialog()">
            <fa-icon [icon]="faUser" class="text-white"></fa-icon> 
          </div>
          <div *ngIf="parent.ProfilePicture && parent.ProfilePicture?.source !== ''" class="profile-pic-initials sm" (click)="openProfilePictureDialog(parent.ProfilePicture.source)">
            <img #profilePic class="img-fluid" [src]="parent.ProfilePicture.source"/>
          </div>
          <div class="m-3 d-flex flex-1">
            <div class="flex-1">
            <h2 class="m-0">{{parent.Name}}</h2>
            <p class="m-0">Category: {{parent.Category ? parent.Category.get('name') : ''}}</p>
            <mat-chip-set><mat-chip disabled>{{parent.Status}}</mat-chip></mat-chip-set>
            <button class="m-0" color="error" mat-flat-button (click)="deleteBusiness()">Delete Business</button>
              </div>
              <div class="">
                <p class="m-0">Mobile: {{parent.Mobile}}</p>
              <p class="m-0">Email: {{parent.Email}}</p>
              <p class="m-0">Website: <a target="_blank" [href]="parent.Website">{{parent.Website}}</a></p>
            </div>
          </div>
        </div>

          <!-- <button mat-raised-button class="text-left btn-block" routerLink="profile" routerLinkActive="active">Profile</button> -->
  </div>
  <div class="h-100 col-md-12 flex-1">
    <router-outlet></router-outlet>   
  </div>
</div>
</div>